const baseModule = 'EVENTS';

export const INIT_STORE = `${baseModule}/INIT_STORE`;
export const UPDATE_STORE_ITEMS = `${baseModule}/UPDATE_STORE_ITEMS`;
